import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import Feedback from "react-bootstrap/esm/Feedback";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axiosApi from "../../axios/axios-api";
import { LogoPetroprix } from "../ui/LogoPetroprix";
import { useDispatch, useSelector } from "react-redux";
import { startLogout } from "../../store/auth";
import { ValidateToken } from "../../helpers/validateToken";

const URL_EDITAR_LIMITES_FLOTA = "flotas/limites/";

export function ModalLimitesCuenta(props) {
  const { id_tar, id_tc } = props;
  const [validated, setValidated] = useState(false);
  const [loadedInfo, setLoadedInfo] = useState(false);
  const { token, flotaActiva } = useSelector((state) => state.auth);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    descripcion: "",
    max_operacion: "120",
    max_imp_red: "1000",
    max_imp_gas: "1000",
    max_op_red: "250",
    max_op_gas: "100",
    max_op_30: "100",
    motivo: "",
  });

  const [validateForm, setValidateForm] = useState({
    max_operacion: false,
    max_imp_red: false,
    max_imp_gas: false,
    max_op_red: false,
    max_op_gas: false,
    max_op_30: false,
    motivo: false,
  });

  const setDailyLimits = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValidated(false);

    const newValidateForm = {
      max_operacion: formData.max_operacion !== "",
      max_imp_red: formData.max_imp_red !== "",
      max_imp_gas: formData.max_imp_gas !== "",
      max_op_red: formData.max_op_red !== "",
      max_op_gas: formData.max_op_gas !== "",
      max_op_30: formData.max_op_30 !== "",
      motivo: formData.motivo !== "",
    };

    setValidateForm(newValidateForm);

    if (Object.values(newValidateForm).some((value) => value === false)) {
      const campoInvalido = Object.keys(newValidateForm).find(
        (key) => newValidateForm[key] === false
      );
      toast(
        t(`flotas.modal.limites.form.validation.${campoInvalido}.invalid`),
        {
          icon: <LogoPetroprix />,
        }
      );
      setValidated(true);
      return;
    }

    setValidated(true);

    const dataSend = {
      max_imp_red: formData.max_imp_red,
      max_imp_gas: formData.max_imp_gas,
      max_op_red: formData.max_op_red,
      max_op_gas: formData.max_op_gas,
      max_op_30: formData.max_op_30,
      motivo: formData.motivo,
    };

    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.put(
          URL_EDITAR_LIMITES_FLOTA + flotaActiva?.id_cuenta,
          dataSend,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (response?.data?.code === 200) {
          props.onHide(true);
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        } else {
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>{t("flotas.modal.limites.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Container>
          <Form
            noValidate
            autoComplete="off"
            onSubmit={(e) => setDailyLimits(e)}
          >
            {/* Importes maximos y nº repostajes diarios */}
            <Row className="">
              <Col sm={12}>
                <Alert variant="primary" className="text-center">
                  {t("flotas.modal.limites.form.info")}
                </Alert>
              </Col>

              <Col sm={12} className="mt-2">
                <FloatingLabel
                  label={t(
                    "flotas.modal.limites.form.imp-max-repost-petroprix"
                  )}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-impMaxRepostPetroprix"
                    placeholder={t(
                      "flotas.modal.limites.form.imp-max-repost-petroprix"
                    )}
                    value={formData.max_imp_red}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_imp_red: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_imp_red}
                  />
                  {validated && !validateForm.max_imp_red && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.imp-max-repost-petroprix.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              <Col sm={12}>
                <FloatingLabel
                  label={t("flotas.modal.limites.form.imp-max-dia-gas")}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-impMaxDiaGas"
                    placeholder={t("flotas.modal.limites.form.imp-max-dia-gas")}
                    value={formData.max_imp_gas}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_imp_gas: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_imp_gas}
                  />
                  {validated && !validateForm.max_imp_gas && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.imp-max-dia-gas.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              <Col sm={12}>
                <FloatingLabel
                  label={t(
                    "flotas.modal.limites.form.num-repost-dia-petroprix"
                  )}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-numRepostDiaPetroprix"
                    placeholder={t(
                      "flotas.modal.limites.form.num-repost-dia-petroprix"
                    )}
                    value={formData.max_op_red}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_op_red: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_op_red}
                  />
                  {validated && !validateForm.max_op_red && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.num-repost-dia-petroprix.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              <Col sm={12}>
                <FloatingLabel
                  label={t("flotas.modal.limites.form.num-repost-dia-gas")}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-numRepostDiaGas"
                    placeholder={t(
                      "flotas.modal.limites.form.num-repost-dia-gas"
                    )}
                    value={formData.max_op_gas}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_op_gas: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_op_gas}
                  />
                  {validated && !validateForm.max_op_gas && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.num-repost-dia-gas.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              <Col sm={12}>
                <FloatingLabel
                  label={t("flotas.modal.limites.form.num-repost-dia-30min")}
                  className="mb-3"
                >
                  <Form.Control
                    type="number"
                    min="0"
                    id="flotas-modal-editar-form-numRepostDia30Min"
                    placeholder={t(
                      "flotas.modal.limites.form.num-repost-dia-30min"
                    )}
                    value={formData.max_op_30}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        max_op_30: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.max_op_30}
                  />
                  {validated && !validateForm.max_op_30 && (
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "flotas.modal.limites.form.validation.num-repost-dia-30min.invalid"
                      )}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>

              {/* Motivo */}
              <Col sm={12}>
                <FloatingLabel
                  label={t("flotas.modal.limites.form.motivo")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-motivo"
                    placeholder={t("flotas.modal.limites.form.motivo")}
                    value={formData.motivo}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        motivo: e.target.value,
                      });
                    }}
                    isInvalid={validated && !validateForm.motivo}
                  />
                  {validated && !validateForm.motivo && (
                    <Form.Control.Feedback type="invalid">
                      {/* Make sure you have a translation key for motivo validation */}
                      {t("flotas.modal.limites.form.validation.motivo.invalid")}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </Col>
            </Row>

            <Row>
              <div className="d-grid gap-2 mt-2 ">
                <Button
                  variant="outline-primary"
                  size="lg"
                  onClick={() => {
                    props.onHide(false);
                  }}
                >
                  {t("flotas.modal.limites.form.btn-cancel")}
                </Button>
                <Button
                  variant="primary"
                  size="lg"
                  type="submit"
                  onClick={(e) => setDailyLimits(e)}
                >
                  {t("flotas.modal.limites.form.btn-guardar")}
                </Button>
              </div>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
